export const TRANSACTION = 'transaction';